import { v4 } from '@rotra-air-ocean/rotranext-shared-code';

export const KIND_DEFAULTS: Record<v4.StepKind, Partial<v4.StepSpec>> = {
  auto: { activity: 'Working…', serviceId: '', next: '' },
  apiCall: { activity: 'Calling…', serviceId: '', next: '' },
  outlookCategory: {
    activity: 'Updating the Outlook category…',
    operation: 'replaceManaged',
    category: '',
    appearance: 'suggested',
    nameFormat: 'humanize',
    next: '',
  },
  userInput: { prompt: 'Please provide:', fields: [], next: '' },
  llm: { activity: 'Thinking…', model: '', prompt: '', output: [], next: '' },
  systemOne: {
    activity: 'Evaluating…',
    model: '',
    stateFields: [],
    questions: {},
    next: '',
  },
  branch: { selectField: '', cases: {}, default: '' },
  decision: {
    prompt: 'Proceed?',
    actions: [
      { label: 'Action 1', next: '' },
      { label: 'Action 2', next: '' },
    ],
  },
  subWorkflow: { workflowId: '', onDone: '' },
  final: { message: 'All done!' },
};

export const KIND_HELP: Record<v4.StepKind, string> = {
  auto: 'Runs a backend service automatically, then continues.',
  apiCall: 'Calls an external API via a backend service.',
  outlookCategory:
    'Adds, replaces, or removes a category on the incoming Outlook email.',
  userInput: 'Asks the user to fill in fields; values join the context.',
  llm: 'Calls an AI model; its output fields join the context.',
  systemOne:
    'Asks a TypeSafe System One model (e.g. Jev) named Choice/Score/Noul questions; each answer joins the context under its question id.',
  branch: 'Routes to a step based on the value of a context field.',
  decision: 'Asks the user to proceed or request changes.',
  subWorkflow: 'Runs another workflow as a nested sub-flow.',
  final: 'Ends the workflow.',
};

export const ID_RE = /^[A-Za-z0-9_]+$/;

export const KIND_ORDER: v4.StepKind[] = [
  'userInput',
  'llm',
  'systemOne',
  'outlookCategory',
  'auto',
  'apiCall',
  'branch',
  'decision',
  'subWorkflow',
  'final',
];
